// src/plugins/vuetify.js

import '@mdi/font/css/materialdesignicons.css'

import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#14245F'
      },
    }
  },
  icons: {
    iconfont: 'mdi',
  },
})
